export const CONTEXT_MENU_TYPES = {
  QUESTIONS: 'Questions',
  COLUMNS: 'Columns',
  ROWS: 'Rows',
  BASES: 'Bases',
  SCRATCH: 'Scratch',
  BASES_WITHOUT_SCRATCH: 'No Scratch',
  COLUMNS_WITHOUT_SCRATCH: 'No Scratch Columns',
  ROWS_WITHOUT_SCRATCH: 'No Scratch Rows',
  DEFAULT: 'DEFAULT',
  CRB: 'CRB',
  SCRATCHONLY: 'SCRATCH',
};

export const CONTEXT_MENU_OPTIONS = {
  FUNCTIONS: 'Functions...',
  ADD_DEFINITION: 'Add to Definition...',
  DELETE_COLUMNS: 'Delete Column(s)',
  DELETE_ROWS: 'Delete Row(s)',
  DELETE_BASES: 'Delete Base(s)',
  DELETE_SCRATCH: 'Delete Scratch',
  SELECT_ALL: 'Select All Items',
  COPY_TO_COLUMNS: 'Copy to Columns',
  COPY_TO_ROWS: 'Copy to Rows',
  COPY_TO_BASES: 'Copy to Bases',
  COPY_TO_SCRATCH: 'Copy to Scratch',
  MOVE_TO_COLUMNS: 'Move to Columns',
  MOVE_TO_ROWS: 'Move to Rows',
  MOVE_TO_BASES: 'Move to Bases',
  MOVE_TO_SCRATCH: 'Move to Scratch',
  EDIT_ROW: 'Edit Row',
  EDIT_COLUMNS: 'Edit Column',
  EDIT_BASES: 'Edit Bases',
  EDIT_EXPRESSION: 'Edit Expression',
  DELETE_LABEL: 'DELETE_LABEL',
  DELETE_ALL: 'DELETE_ALL',
};

const {
  FUNCTIONS,
  ADD_DEFINITION,
  DELETE_COLUMNS,
  DELETE_ROWS,
  DELETE_BASES,
  DELETE_SCRATCH,
  SELECT_ALL,
  COPY_TO_COLUMNS,
  COPY_TO_ROWS,
  COPY_TO_BASES,
  COPY_TO_SCRATCH,
  MOVE_TO_COLUMNS,
  MOVE_TO_ROWS,
  MOVE_TO_BASES,
  MOVE_TO_SCRATCH,
} = CONTEXT_MENU_OPTIONS;

export const getContextMenuOptions = contextMenuType => {
  switch (contextMenuType) {
    case CONTEXT_MENU_TYPES.DEFAULT:
      return [FUNCTIONS, ADD_DEFINITION, SELECT_ALL];
    case CONTEXT_MENU_TYPES.CRB:
      return [MOVE_TO_COLUMNS, MOVE_TO_ROWS, MOVE_TO_BASES];
    case CONTEXT_MENU_TYPES.SCRATCHONLY:
      return [MOVE_TO_SCRATCH];
    case CONTEXT_MENU_TYPES.QUESTIONS:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        SELECT_ALL,
        MOVE_TO_COLUMNS,
        MOVE_TO_ROWS,
        MOVE_TO_BASES,
        MOVE_TO_SCRATCH,
      ];
    case CONTEXT_MENU_TYPES.COLUMNS:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        DELETE_COLUMNS,
        SELECT_ALL,
        MOVE_TO_ROWS,
        MOVE_TO_BASES,
        MOVE_TO_SCRATCH,
        COPY_TO_ROWS,
        COPY_TO_BASES,
        COPY_TO_SCRATCH,
      ];
    case CONTEXT_MENU_TYPES.COLUMNS_WITHOUT_SCRATCH:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        DELETE_COLUMNS,
        SELECT_ALL,
        MOVE_TO_ROWS,
        MOVE_TO_BASES,
        COPY_TO_ROWS,
        COPY_TO_BASES,
      ];
    case CONTEXT_MENU_TYPES.ROWS:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        DELETE_ROWS,
        SELECT_ALL,
        MOVE_TO_COLUMNS,
        MOVE_TO_BASES,
        MOVE_TO_SCRATCH,
        COPY_TO_COLUMNS,
        COPY_TO_BASES,
        COPY_TO_SCRATCH,
      ];
    case CONTEXT_MENU_TYPES.ROWS_WITHOUT_SCRATCH:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        DELETE_ROWS,
        SELECT_ALL,
        MOVE_TO_COLUMNS,
        MOVE_TO_BASES,
        COPY_TO_COLUMNS,
        COPY_TO_BASES,
      ];
    case CONTEXT_MENU_TYPES.BASES:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        DELETE_BASES,
        SELECT_ALL,
        MOVE_TO_COLUMNS,
        MOVE_TO_ROWS,
        MOVE_TO_SCRATCH,
        COPY_TO_COLUMNS,
        COPY_TO_ROWS,
        COPY_TO_SCRATCH,
      ];
    case CONTEXT_MENU_TYPES.BASES_WITHOUT_SCRATCH:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        DELETE_BASES,
        SELECT_ALL,
        MOVE_TO_COLUMNS,
        MOVE_TO_ROWS,
        COPY_TO_COLUMNS,
        COPY_TO_ROWS,
      ];
    case CONTEXT_MENU_TYPES.SCRATCH:
      return [
        FUNCTIONS,
        ADD_DEFINITION,
        DELETE_SCRATCH,
        SELECT_ALL,
        MOVE_TO_COLUMNS,
        MOVE_TO_ROWS,
        MOVE_TO_BASES,
        COPY_TO_COLUMNS,
        COPY_TO_ROWS,
        COPY_TO_BASES,
      ];

    default:
      return [];
  }
};
